var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-dropdown-section',{attrs:{"title":"Applications Sent","type":"locum-applications-sent","items-shown":5,"items":_vm.requests,"event-name":"load-locum-applications-sent"},on:{"load-locum-applications-sent":_vm.loadMore}})}
var staticRenderFns = []

export { render, staticRenderFns }